<template>
  <div class="border-t border-gray-200 px-4 py-4">
    <div class="flex justify-between items-center pb-2">
      <span class="text-sm font-bold">Subtotal</span>
      <span class="text-sm font-medium">{{ subtotalFormatted }}</span>
    </div>

    <div v-if="discount" class="flex justify-between items-center pb-2">
      <span class="text-sm font-bold">{{ discount.label }}</span>
      <span class="text-sm font-medium">- {{ discount.amountFormatted }}</span>
    </div>

    <div v-if="fulfillmentDiscount" class="flex justify-between items-center pb-2">
      <span class="text-sm font-bold">{{ fulfillmentDiscount.label }}</span>
      <span class="text-sm font-medium">- {{ fulfillmentDiscount.amountFormatted }}</span>
    </div>

    <div v-if="deliveryFormatted" class="flex justify-between items-center pb-2">
      <span class="text-sm font-bold">{{ deliveryLabel }}</span>
      <span class="text-sm font-medium">
        <s v-if="deliveryOriginalFormatted" class="text-gray-400 mr-1">{{ deliveryOriginalFormatted }}</s>
        {{ deliveryFormatted }}
      </span>
    </div>

    <div v-if="taxes" class="pb-2">
      <button
        v-if="taxes.breakdown && taxes.breakdown.length"
        type="button"
        data-test="taxes-toggle"
        class="w-full flex justify-between items-center cursor-pointer"
        @click="showBreakdown = !showBreakdown"
      >
        <span class="text-sm font-bold flex items-center">
          {{ taxes.label }}
          <ChevronDownIcon class="w-4 h-4 ml-1 transition-transform" :class="{ 'rotate-180': showBreakdown }" />
        </span>
        <span class="text-sm font-medium">{{ taxes.totalFormatted }}</span>
      </button>
      <div v-else class="flex justify-between items-center">
        <span class="text-sm font-bold">{{ taxes.label }}</span>
        <span class="text-sm font-medium">{{ taxes.totalFormatted }}</span>
      </div>
      <div v-if="showBreakdown" data-test="taxes-breakdown">
        <div v-for="fee in taxes.breakdown" :key="fee.description" class="flex justify-between items-center">
          <span class="text-sm text-gray-500">{{ fee.description }}</span>
          <span class="text-sm text-gray-500">{{ fee.amountFormatted }}</span>
        </div>
      </div>
    </div>

    <div v-if="tip" class="flex justify-between items-center pb-2">
      <span class="text-sm font-bold">{{ tip.label }}</span>
      <span class="text-sm font-medium">{{ tip.amountFormatted }}</span>
    </div>

    <div
      v-if="credits.length"
      data-test="credits-section"
      class="border-t border-gray-200 mt-2 pt-3"
      :class="{ '-mx-4 px-4': fullBleedDividers }"
    >
      <div v-for="credit in credits" :key="credit.label" class="flex justify-between items-center pb-2">
        <span class="text-sm font-medium text-gray-600">{{ credit.label }}</span>
        <span class="text-sm font-medium">- {{ credit.amountFormatted }}</span>
      </div>
    </div>

    <div
      class="border-t border-gray-200 mt-2 pt-3 flex justify-between items-center"
      :class="{ '-mx-4 px-4': fullBleedDividers }"
    >
      <span class="text-base font-bold">Today's Total</span>
      <span class="text-base font-bold">{{ todaysTotalFormatted }}</span>
    </div>
  </div>
</template>

<script>
import { ChevronDownIcon } from '@heroicons/vue/solid'

export default {
  name: 'OrderSummaryTotals',
  components: { ChevronDownIcon },
  props: {
    subtotalFormatted: { type: String, required: true },
    discount: { type: Object, default: null },
    fulfillmentDiscount: { type: Object, default: null },
    deliveryFormatted: { type: String, default: null },
    deliveryOriginalFormatted: { type: String, default: null },
    deliveryLabel: { type: String, default: 'Delivery Fee' },
    taxes: { type: Object, default: null },
    tip: { type: Object, default: null },
    credits: { type: Array, default: () => [] },
    todaysTotalFormatted: { type: String, required: true },
    // Stretch the divider hairlines edge-to-edge (drawer); checkout keeps them inset.
    fullBleedDividers: { type: Boolean, default: false }
  },
  data() {
    return { showBreakdown: false }
  }
}
</script>
